import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiPost } from '@/lib/api';

interface RetryCampaignStepResponse {
  ok: boolean;
  workflow_id: string;
}

export function useRetryCampaignStep(campaignId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (stepId: string) =>
      apiPost<RetryCampaignStepResponse>(
        `/v1/campaigns/${campaignId}/steps/${stepId}/retry`,
        {},
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['campaign-steps', campaignId] });
      void qc.invalidateQueries({ queryKey: ['campaign-events', campaignId] });
      void qc.invalidateQueries({ queryKey: ['campaign', campaignId] });
    },
  });
}
